'use client';

import { usePathname } from 'next/navigation';
import { useState, useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';

export default function ConditionalDefaultLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const [isMarketSubdomain, setIsMarketSubdomain] = useState(() => {
    // SSR дээр subdomain шалгах
    if (typeof window !== 'undefined') {
      const hostname = window.location.hostname;
      return hostname.startsWith('market.');
    }
    return false;
  });

  // Subdomain шалгах (hydration-ийн дараа)
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const hostname = window.location.hostname;
      const isMarket = hostname.startsWith('market.');
      setIsMarketSubdomain(isMarket);
    }
  }, []);

  const isHrMarket =
    pathname?.startsWith('/hr-market') || pathname?.startsWith('/if-hr-market');
  const isUniversity = pathname?.startsWith('/university');
  const isOAuth = pathname?.startsWith('/oauth');
  const isAuthPage =
    pathname?.startsWith('/account/login') ||
    pathname?.startsWith('/account/register');

  // Subdomain эсвэл hr-market pathname дээр байвал ConditionalDefaultLayout header render хийхгүй
  // (учир нь HrMarketLayoutClient дээр аль хэдийн HrMarketHeader байна)
  // /university, /oauth, /account/login, /account/register хуудсанд header, footer харуулахгүй
  if (
    isHrMarket ||
    isMarketSubdomain ||
    isUniversity ||
    isOAuth ||
    isAuthPage
  ) {
    return <>{children}</>;
  }

  return (
    <>
      <Header />
      <main className="grow">{children}</main>
      <Footer />
    </>
  );
}
